import React from 'react';
import {connect} from 'react-redux';

import {CONTROL_TYPE} from '../../../utils/enums';

import SectionItemText from '../SectionItemText';
import SectionItemTextArea from '../SectionItemTextArea';
import SectionItemNumber from '../SectionItemNumber';
import SectionItemCheckBox from '../SectionItemCheckBox';
import SectionItemHeader from '../SectionItemHeader';
import SectionItemAddress from '../SectionItemAddress';
import SectionItemCity from '../SectionItemCity';
import SectionItemRoleSelector from '../SectionItemRoleSelector';
import SectionItemSelect from '../SectionItemSelect';
import SectionItemLink from '../SectionItemLink';
import SectionItemPassword from '../SectionItemPassword';
import SectionItemImage from '../SectionItemImage';
import SectionItemListItems from '../SectionItemListItems';
import SectionItemSelectWithAdd from '../SectionItemSelectWithAdd';
import SectionItemSwitch from '../SectionItemSwitch';
import SectionItemSwitchGroups from '../SectionItemSwitchGroups';
import SectionItemMapAddress from '../SectionItemMapAddress';
import SectionItemDate from '../SectionItemDate';
import SectionItemLinkdownload from '../SectionItemLinkdownload';
import MapRegionControl from '../MapRegionControl';
import SectionItemFrameControl from '../SectionItemFrameControl';
import SectionItemArrayItems from '../SectionItemArrayItems';
import SectionItemInterval from '../SectionItemInterval';
import SectionItemVehicleSelector from '../SectionItemVehicleSelector';
import SectionItemPaymeRadioButtons from '../SectionItemPaymeRadioButtons';
import SectionItemLanguageEditor from '../SectionItemLanguageEditor';
import SectionItemPaymentsConfiguration from '../SectionItemPaymentsConfiguration';
import ScheduleControl from '../ScheduleControl';
import SectionItemEditableTable from '../SectionItemEditableTable';
import SectionItemSettingImageEdit from '../SectionItemSettingImageEdit';
import SectionItemLinkControl from '../SectionItemLinkControl';
import SectionItemRadioButton from '../SectionIremRadioButton/SectionItemRadioButton';
import SectionItemButton from '../SectionItemButton';
import SectionHtmlEditor from '../SectionRichText';
import DepotSquareAssociatedLocations from '../DepotSquareAssociatedLocations';
import SectionNestedItem from '../SectionNestedItem/SectionNestedItem';
import IconWithQuantity from '../IconWithQuantity';
import {SectionItemCopyToClipboard} from '../SectionItemCopyToClipboard/SectionItemCopyToClipboard';
import {SectionItemMobileMenu} from '../SectionItemMobileMenu/SectionItemMobileMenu';
import ControlCentersList from '../ControlCentersList';
import AllowedDepotsList from '../AllowedDepotsList';
import SectionItemDeepLinkStats from '../SectionItemDeepLinkStats';
import UsersPopup from '../ControlCentersManagersList/UsersPopup.jsx';
import SectionItemInlineLabel from '../SectionItemInlineLabel/SectionItemInlineLabel.jsx';
import SectionItemAudienceFilter from '../SectionItemAudienceFilter/index.js';
import SectionItemBonusVoucher from '../SectionItemBonusVoucher/SectionItemBonusVoucher.jsx';
import SectionItemMultiselect from '../SectionItemMultiselect/index.js';
import SectionItemModalSelect from '../SectionItemModalSelect/index.js';
import SectionItemTranslationTable from '../SectionItemTranslationTable/SectionItemTranslationTable.jsx';
import SectionItemMapByLocation from "../SectionItemMapByLocation/index.js";
import SectionItemIcon from "../SectionItemIcon/SectionItemIcon.jsx";
import SectionItemIconSelector from "../SectionItemIconSelector/SectionItemIconSelector.jsx";
import SectionItemReconciliationFeesTable from '../SectionItemReconciliationFeesTable/index.js';
import SectionItemReconciliationPeriodsTable from '../SectionItemReconciliationPeriodsTable/index.js';
import ReconciliationsMultiSelect from "../ReconciliationsMultiSelect/index.js";
import DefaultMultiSelect from "../DefaultMultiSelect/index.js";
import DepotPaymentSelector from "../DepotPaymentSelector/index.js";
import SectionItemKeywords from "../SectionItemKeywords/index.js";
import SingleLapseControl from '../SingleLapseControl/SingleLapseControl.jsx';
import SectionItemSkuOverride from '../SectionItemSkuOverride/SectionItemSkuOverride.jsx';
import SectionItemPriceOverride from '../SectionItemPriceOverride/SectionItemPriceOverride.jsx';
import SectionItemMenuData from '../SectionItemMenuData/SectionItemMenuData.jsx';
import SectionItemAddItem from '../SectionItemAddItem/SectionItemAddItem.jsx';
import SectionItemSelectRegionWithAdd from '../SectionItemSelectRegionWithAdd/SectionItemSelectRegionWithAdd.jsx';

export const DefaultSectionItem = () => <div />;

export const sectionItemEditComponents = {
  [CONTROL_TYPE.text]: SectionItemText,
  [CONTROL_TYPE.inlineLabel]: SectionItemInlineLabel,
  [CONTROL_TYPE.textArea]: SectionItemTextArea,
  [CONTROL_TYPE.number]: SectionItemNumber,
  [CONTROL_TYPE.checkbox]: SectionItemCheckBox,
  [CONTROL_TYPE.controlCentersList]: ControlCentersList,
  [CONTROL_TYPE.usersPopup]: UsersPopup,
  [CONTROL_TYPE.allowedDepotsList]: AllowedDepotsList,
  [CONTROL_TYPE.sectionName]: SectionItemHeader,
  [CONTROL_TYPE.address]: SectionItemAddress,
  [CONTROL_TYPE.roleSelector]: SectionItemRoleSelector,
  [CONTROL_TYPE.vehicleSelector]: SectionItemVehicleSelector,
  [CONTROL_TYPE.select]: SectionItemSelect,
  [CONTROL_TYPE.multiselect]: SectionItemMultiselect,
  [CONTROL_TYPE.link]: SectionItemLink,
  [CONTROL_TYPE.linkControl]: SectionItemLinkControl,
  [CONTROL_TYPE.password]: SectionItemPassword,
  [CONTROL_TYPE.image]: SectionItemImage,
  [CONTROL_TYPE.iconsSelector]: SectionItemIconSelector,
  [CONTROL_TYPE.icon]: SectionItemIcon,
  [CONTROL_TYPE.imageEdit]: SectionItemSettingImageEdit,
  [CONTROL_TYPE.date]: SectionItemDate,
  [CONTROL_TYPE.listItem]: SectionItemListItems,
  [CONTROL_TYPE.arrayItems]: SectionItemArrayItems,
  [CONTROL_TYPE.editTable]: SectionItemEditableTable,
  [CONTROL_TYPE.selectWithAdd]: SectionItemSelectWithAdd,
  [CONTROL_TYPE.selectRegionWithAdd]: SectionItemSelectRegionWithAdd,
  [CONTROL_TYPE.addList]: SectionItemAddItem,
  [CONTROL_TYPE.keywords]: SectionItemKeywords,
  [CONTROL_TYPE.switch]: SectionItemSwitch,
  [CONTROL_TYPE.switchGroups]: SectionItemSwitchGroups,
  [CONTROL_TYPE.mapAddress]: SectionItemMapAddress,
  [CONTROL_TYPE.mapRegion]: MapRegionControl,
  [CONTROL_TYPE.mapByLocation]: SectionItemMapByLocation,
  [CONTROL_TYPE.cityAddress]: SectionItemCity,
  [CONTROL_TYPE.linkDownload]: SectionItemLinkdownload,
  [CONTROL_TYPE.frame]: SectionItemFrameControl,
  [CONTROL_TYPE.selectInterval]: SectionItemInterval,
  [CONTROL_TYPE.paymeRadioButtons]: SectionItemPaymeRadioButtons,
  [CONTROL_TYPE.depotPaymentSelector]: DepotPaymentSelector,
  [CONTROL_TYPE.paymeConfiguration]: SectionItemPaymentsConfiguration,
  [CONTROL_TYPE.languageEditor]: SectionItemLanguageEditor,
  [CONTROL_TYPE.schedule]: ScheduleControl,
  [CONTROL_TYPE.singleLaspe]: SingleLapseControl,
  [CONTROL_TYPE.radioButton]: SectionItemRadioButton,
  [CONTROL_TYPE.button]: SectionItemButton,
  [CONTROL_TYPE.richText]: SectionHtmlEditor,
  [CONTROL_TYPE.squareAssociatedLocations]: DepotSquareAssociatedLocations,
  [CONTROL_TYPE.nestedItem]: SectionNestedItem,
  [CONTROL_TYPE.iconWithQuantity]: IconWithQuantity,
  [CONTROL_TYPE.copyToClipboard]: SectionItemCopyToClipboard,
  [CONTROL_TYPE.mobileMenu]: SectionItemMobileMenu,
  [CONTROL_TYPE.deepLinkStat]: SectionItemDeepLinkStats,
  [CONTROL_TYPE.audienceFilter]: SectionItemAudienceFilter,
  [CONTROL_TYPE.bonusVoucher]: SectionItemBonusVoucher,
  [CONTROL_TYPE.modalSelect]: SectionItemModalSelect,
  [CONTROL_TYPE.translationTable]: SectionItemTranslationTable,
  [CONTROL_TYPE.skuOverride]: SectionItemSkuOverride,
  [CONTROL_TYPE.priceOverride]: SectionItemPriceOverride,
  [CONTROL_TYPE.menuData]: SectionItemMenuData,
  [CONTROL_TYPE.reconciliationFeesTable]: SectionItemReconciliationFeesTable,
  [CONTROL_TYPE.reconciliationPeriodsTable]: SectionItemReconciliationPeriodsTable,
  [CONTROL_TYPE.reconciliationMultiSelect]: ReconciliationsMultiSelect,
  [CONTROL_TYPE.defaultMultiSelect]: DefaultMultiSelect,
  default: DefaultSectionItem
};

export default function getSectionItemEditComponent(tag, connectLambda, item) {
  const component = sectionItemEditComponents[tag || "default"];

  // fix for reload on fly
  const connectHelper = (mapStateToProps) => {
      return connectLambda({ ...mapStateToProps, localValue: item });
  }

  return connectLambda ? connect(connectHelper)(component) : component;
}
